module.exports = require("/codebuild/output/src1361162438/src/phx-global-form-gatsby/src/gatsby/gatsby-browser.ts");